import * as React from 'react';

import { Alert } from '@lightspeed/flame/Alert';
import { Box } from '@lightspeed/flame/Core';

type DangerAlertProps = {
  noCloseBtn?: boolean;
  title?: string;
  message: string | React.ReactNode;
  dataTest?: string;
};
export const DangerAlert = ({
  noCloseBtn = false,
  title,
  message,
  dataTest = 'error-alert',
}: DangerAlertProps) => {
  return (
    <>
      <Alert data-test={dataTest} type="danger" noCloseBtn={noCloseBtn} title={title} mb={2}>
        <Box data-test="error-alert-message">{message}</Box>
      </Alert>
    </>
  );
};
